import styled from 'styled-components';

export const GridLayout = styled.div`
  display: grid;
  /* justify-content: start; */
  width: 100%;
  height: 100%;
  grid-template-columns: 16.6% 16.6% 16.6% 16.6% 16.6% ;
  grid-template-rows: 1fr auto auto;
  grid-template-areas:
    "opdracht opdracht opdracht opdracht    hint    hint"
    "height   height   height   height  height  height"
    "input    input    input    input   input   input";
  @media(max-width:  900px) {
    height: 100%;
    grid-template-columns: auto ;
    grid-template-rows: 1fr auto auto;
    grid-template-areas:
      "opdracht"
      "hint"
      "input";
    }
`;


export const PageContainer = styled.div`
  display: block;
  text-align: center;
`;

export const GridInput = styled.div`
  height: auto;
  display: flex;
  justify-content: center;
  grid-area: input;
`;

export const GridHint = styled.div`
  grid-area: hint;
`;

export const GridOpdracht = styled.div`
  grid-area: opdracht;
`;

export const LogoStyle = styled.img`
  width: 250px;
  height: 45px;
  display: flex;
  justify-content: center;
  @media(max-width: 900px) {
    width: 250px;
    height: 45px;
  }
`;

export const LogoHeading = styled.div`
  width: 100%;
  height: auto;
  margin: 25px 0 25px 0;
  display: flex;
  justify-content: center;
`;

export const TimeDeduct = styled.p`
	display: none;
	opacity: 0;
	height: 40px;
	width: 100%;
	overflow: hidden;
	color: red;
	text-align: center;
	font-family: 'Staatliches';

  ${({ active }) => active && `
  display: block;
  font-size: 24px;
  height: 40px;
  position: absolute;
  margin: 0 auto;
`}
`

export const TimeValue = styled.h1`
  ${({ overTime }) => overTime && `
    color: red!important;
`}
`;


